module.exports = __webpack_public_path__ + "media/static/icons/icon-legend-buoys-00812845ac348016c3da560c5d7b9f0d.svg";